import React from 'react';
import styles from './VideoShowcase.module.css';

const VideoShowcase = () => {
    return (
        <section className={styles.videoSection}>
            <div className={styles.container}>
                <div className={styles.videoHeader}>
                    <h2>What 3 mins daily practice can do for you? Must Watch</h2>
                    <div className={styles.divider}></div>
                </div>

                <div className={styles.videoWrapper}>
                    <iframe
                        className={styles.videoFrame}
                        src="https://www.youtube.com/embed/c8_BIamLESg?start=100"
                        title="Presentation Skills Training Video"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>

                <div className={styles.attribution}>
                    <p>This video is created by Conor Neill and is shared here from YouTube for educational purposes only.</p>
                </div>
            </div>
        </section>
    );
};

export default VideoShowcase;